import { ActionStatus } from "../../../common/constants/action-status";
import { StoreState } from "../../../store/store.interface";

export const isLoadingInclusiveAccess = (state: StoreState) => state.inclusiveAccessState.status === ActionStatus.loading;
export const isSucceededInclusiveAccess = (state: StoreState) => state.inclusiveAccessState.status === ActionStatus.succeeded;